module.exports = __webpack_public_path__ + "sgby/img/news-item-line.24691b1.png";